import React, { useEffect } from 'react';

const About = () => {
    const imageSrc = `/images/jermingo/`;
    const baseUrl = 'https://jermingo.com';
    
    useEffect(() => {
        // Update document title
        document.title = 'About Us | Jermingo';
        
        // Update meta description
        let metaDesc = document.querySelector('meta[name="description"]');
        if (!metaDesc) {
            metaDesc = document.createElement('meta');
            metaDesc.setAttribute('name', 'description');
            document.head.appendChild(metaDesc);
        }
        metaDesc.setAttribute('content', 
            'Learn about Jermingo - two friends planning a one-year sabbatical in 2028 to explore, learn, and live our best lives. Join us on our travel adventures!'
        );
        
        // Add canonical URL
        let canonical = document.querySelector('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement('link');
            canonical.setAttribute('rel', 'canonical');
            document.head.appendChild(canonical);
        }
        canonical.setAttribute('href', `${baseUrl}/about`);
    }, []);
    
    return (
        <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif', lineHeight: '1.6', maxWidth: '800px', margin: '0 auto' }}>
            <h1>About Us</h1>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', marginBottom: '2rem', flexWrap: 'wrap' }}>
                <img 
                    src={`${imageSrc}ming.jpg`} 
                    alt="Ming from Jermingo travel blog" 
                    style={{ height: '20em', borderRadius: '8px' }} 
                />
                <img 
                    src={`${imageSrc}jermaine.png`} 
                    alt="Jermaine from Jermingo travel blog" 
                    style={{ height: '20em', borderRadius: '8px' }} 
                />
            </div>
            <p>
                We're Ming and Jermaine—two friends who share a passion for travel, adventure, and living intentionally. 
                Jermingo started as a way for us to document our journeys, share what we've learned on the road, 
                and connect with others who believe that exploring the world can change how you see everything else.
            </p>
            <p>
                Over the years, we've traveled to cities across Asia, Europe, and beyond. We've navigated language barriers, 
                figured out budgets on the fly, and learned that the best trips often come from saying yes to the unexpected. 
                Whether it's a weekend in Barcelona, a budget week in Bangkok, or a few days discovering Tokyo, 
                we write about our real experiences—what worked, what we'd do differently, and the moments that made each trip memorable.
            </p>
            <p>
                We're currently in the planning stages of something bigger: a one-year sabbatical in 2028. 
                We're saving, researching, and building the life we want—one where travel isn't a luxury we squeeze into two weeks a year, 
                but a core part of how we live. This blog is our way of sharing that journey, from the practical tips 
                (like how to pack light or budget for a trip) to the bigger lessons travel teaches us about ourselves and the world.
            </p>
            <p>
                Our goal is simple: to inspire and help others explore. We believe travel is for everyone—whether you're 
                a first-time traveler or a seasoned adventurer, whether you have a week or a year. We share honest, 
                practical guides, personal stories, and the kind of advice we wish we'd had before our own trips.
            </p>
            <p>
                Life's too short to not take a break and see the world. Thanks for being here—we're glad you found us. 
                Stay tuned for more adventures, and feel free to reach out if you have questions or want to share your own travel stories.
            </p>
        </div>
    );
};

export default About;